import { useNetworkStatusStore } from '../stores/networkStatusStore'

export function useNetworkStatus(): { isOffline: boolean } {
  const isOffline = useNetworkStatusStore((state) => state.isOffline)
  return { isOffline }
}
